module.exports = "/images/hifos-logo.png?647572b462a8d5272c2eccfe6d16493b";